/*
 *
 * LanguageProvider
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { useLocaleStore } from '../../stores/localeStore';

export function LanguageProvider(props) {
  const locale = useLocaleStore(state => state.locale);
  return (
    <IntlProvider
      locale={locale}
      messages={props.messages[locale]}
      defaultLocale="sv"
    >
      {React.Children.only(props.children)}
    </IntlProvider>
  );
}

LanguageProvider.propTypes = {
  messages: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
};

export default LanguageProvider;
